import { isValidElement, Children } from 'react';
function map(children, func) {
    var index = 0;
    return Children.map(children, function (child) {
        return isValidElement(child) ? func(child, index++) : child;
    });
}
function forEach(children, func) {
    var index = 0;
    Children.forEach(children, function (child) {
        if (isValidElement(child))
            func(child, index++);
    });
}
function isValid(parentTypeName, childTypeName, children) {
    if (!children)
        return null;
    Children.forEach(children, function (child) {
        if (child.type.name === childTypeName)
            return undefined;
        var childIdentifier = isValidElement(child)
            ? child.type.displayName || child.type.name || child.type
            : child;
        throw new Error("Children of " + parentTypeName + " can contain only " + childTypeName + " " +
            ("components. Found " + childIdentifier + "."));
    });
}
export { map, forEach, isValid };
